import React from "react";
import "./SubscriptionPage.css";

const SubscriptionPage = () => {
   const plans = [
    {
      title: "Starter Plan",
      price: "₹10,000 / year",
      description: "Best for startups and small businesses starting out.",
      features: [
        "Up to ₹1 Cr/month transaction volume",
        "40% UPI GTV minimum",
        "12 months discounted pricing",
      ],
      btnText: "subscription Now",
      color: "#4CAF50",
    },
    {
      title: "Growth Plan",
      price: "₹15,000 / year",
      description: "Perfect for growing brands expanding their reach.",
      features: [
        "Higher transaction limits",
        "Priority support",
        "International card acceptance",
      ],
      btnText: "subscription Now",
      color: "#007bff",
    },
    {
      title: "Business Plan",
      price: "₹20,000 / year",
      description: "Ideal for established companies with high volume.",
      features: [
        "Dedicated account manager",
        "Custom pricing available",
        "24/7 WhatsApp support",
      ],
      btnText: "subscription Now",
      color: "#FF9800",
    },
    {
      title: "Premium Plan",
      price: "₹25,000 / year",
      description: "Designed for enterprises needing premium features.",
      features: [
        "Unlimited transaction volume",
        "Dedicated technical support",
        "Custom settlement cycle",
      ],
      btnText: "subscription Now",
      color: "#9C27B0",
    },
  ];

  return (
    <div className="pricing-page">
      <h1 className="main-heading">Lowest payment gateway charges in India</h1>
      <p className="sub-text">Choose the perfect plan for your business</p>

      <div className="plan-container">
        {plans.map((plan, index) => (
<div key={index} className={`plan-card border${index + 1}`}>
            <h3>{plan.title}</h3>

            <h1 style={{ color: plan.color }}>
              {plan.rate}
              {plan.oldRate && <span className="old-rate">{plan.oldRate}</span>}
            </h1>

            <p className="desc">{plan.description}</p>
            <ul>
              {plan.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>

            {/* Added Plan Price Section */}
            <div className={`plan-price pricebg${index + 1}`}>
              <span>{plan.price}</span>
            </div>

            <button
              className="subscription-btn"
              style={{ backgroundColor: plan.color }}
            >
              {plan.btnText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPage;
